import "../Styles/Register.css";
import "../Styles/style.css";
import Input from "../Shared/Input";
import Checkbox from "@mui/material/Checkbox";
import NextButton from "../Shared/NextButton";
import CalendarPicker from "../Shared/CalendarPicker";
import { FormControlLabel, FormHelperText } from "@mui/material";
import consts from "../Utilities/appConsts.json";
import useRegisterForm from "../hook/useRegisterForm";
import { validation } from "../Utilities/validations";
import ModalAlert from "../Shared/ModalAlert";
import { renderTermsTemplate } from "../Utilities/renderTermsTemplate";

function Register() {
  const {
    formData,
    handleChangeFormData,
    isShowHelperTextPassword,
    isShowHelperTextFirstName,
    isShowHelperTextLastName,
    isShowHelperTextEmail,
    isShowHelperTextPhone,
    setIsShowHelperTextEmail,
    handleChange,
    setIsError,
    checkedTerms,
    setCheckedTerms,
    checkedNewsletter,
    checkboxClicked,
    setCheckedNewsletter,
    handleOnClick,
    getTranslation,
    isShowHelperSecondPassword,
    setIsShowHelperTextSecondPassword,
    setIsShowHelperTextFirstName,
    setIsShowHelperTextLastName,
    setIsShowHelperTextPhone,
    setIsShowHelperTextPassword,
    setIsAddBirthdayModal,
    isAddBirthdayModal,
    loading,
    LoaderComponent,
    licenseTemplate,
    placeholders,
  } = useRegisterForm();

  return (
    <>
      <LoaderComponent loading={loading}></LoaderComponent>
      <ModalAlert
        open={isAddBirthdayModal}
        onClose={(isApproved: boolean) => {
          setIsAddBirthdayModal(false);
          isApproved && setCheckedNewsletter(true);
        }}
        title="לא חבל?"
        content="רק באישור קבלת דוא”ל פרסומי נוכל לפרגן בהטבת יום הולדת ובהטבות נוספות"
        textTrue="תרשמו אותי"
        textFalse="בפעם אחרת"
      />

      <div className="position">
        <div className="register-Typography">
          <h1 className="register-text">
            {getTranslation(consts.CRETE_ACCOUNT_LUPA)}
          </h1>
        </div>
        <div className="register-Typography">
          <p className="register-Typography-text">
            {getTranslation(
              consts.LUPA_ACCOUNT_ALLOWS_YOU_TO_KEEP_TRACK_OF_THE_LUPA_YOU_BOUGHT
            )}
          </p>
        </div>
        <Input
          label={getTranslation(consts.FIRST_NAME)}
          className="textField mt-imput-register"
          name={"firstName"}
          characterLimit={20}
          isRequired={true}
          testid="first-name-input-register"
          variant="standard"
          setIsError={setIsError}
          setShowHelperText={setIsShowHelperTextFirstName}
          showHelperText={isShowHelperTextFirstName}
          helperText={
            isShowHelperTextFirstName &&
            validation("", getTranslation(consts.FIRST_NAME)).helperText
          }
          value={formData.firstName}
          setValue={(name: any, value: any, setShowHelperText: any) =>
            handleChangeFormData(name, value, setShowHelperText)
          }
        />
        <Input
          label={getTranslation(consts.LAST_NAME)}
          className="textField mt-imput-register"
          name={"lastName"}
          characterLimit={20}
          testid="last-name-input-register"
          isRequired={true}
          variant="standard"
          setIsError={setIsError}
          setShowHelperText={setIsShowHelperTextLastName}
          showHelperText={isShowHelperTextLastName}
          helperText={
            isShowHelperTextLastName &&
            validation("", getTranslation(consts.LAST_NAME)).helperText
          }
          //showHelperText={true}
          value={formData.lastName ? formData.lastName : ""}
          setValue={(name: any, value: any, setShowHelperText: any) =>
            handleChangeFormData(name, value, setShowHelperText)
          }
        />
        <Input
          label={getTranslation(consts.EMAIL)}
          className="textField mt-imput-register"
          name={"mail"}
          characterLimit={50}
          isRequired={true}
          testid="email-input-register"
          variant="standard"
          setShowHelperText={setIsShowHelperTextEmail}
          showHelperText={isShowHelperTextEmail ? true : false}
          helperText={isShowHelperTextEmail && "זה מייל שיש לו כבר חשבון בלופה"}
          setIsError={setIsError}
          endAdornment={false}
          value={formData.mail ? formData.mail : ""}
          setValue={(name: any, value: any, setShowHelperText: any) =>
            handleChangeFormData(name, value, setShowHelperText)
          }
        />
        <CalendarPicker
          name={"date"}
          date={formData.date}
          setValue={(date: any) => handleChangeFormData("date", date)}
        />
        <Input
          label={getTranslation(consts.PHONE_NUMBER)}
          className="textField mt-imput-register"
          name={"phoneNumber"}
          onlyNumber={true}
          characterLimit={9}
          isRequired={true}
          variant="standard"
          testid="phone-input-register"
          setShowHelperText={setIsShowHelperTextPhone}
          showHelperText={isShowHelperTextPhone ? true : false}
          helperText={
            isShowHelperTextPhone &&
            validation("", getTranslation(consts.PHONE_NUMBER)).helperText
          }
          value={formData.phoneNumber ? formData.phoneNumber : ""}
          setValue={(name: any, value: any, setShowHelperText: any) =>
            handleChangeFormData(name, value, setShowHelperText)
          }
        />

        <Input
          label={getTranslation(consts.YOUR_PASSWORD)}
          className="textField mt-imput-register"
          name={"password"}
          characterLimit={20}
          isRequired={true}
          type={"password"}
          variant="standard"
          testid="pass-input-register"
          setShowHelperText={setIsShowHelperTextPassword}
          showHelperText={isShowHelperTextPassword}
          setIsError={setIsError}
          helperText={
            isShowHelperTextPassword &&
            validation("", getTranslation(consts.YOUR_PASSWORD)).helperText
          }
          //showHelperText={true}
          endAdornment={true}
          value={formData.password ? formData.password : ""}
          setValue={(name: any, value: any, setShowHelperText: any) =>
            handleChangeFormData(name, value, setShowHelperText)
          }
        />
        <Input
          label={getTranslation(consts.PLEASE_TYPE_CONFIRM_PASSWORD)}
          className="textField mt-imput-register"
          name={"secondPassword"}
          type={"password"}
          characterLimit={20}
          isRequired={true}
          testid="sec-pass-input-register"
          variant="standard"
          showHelperText={isShowHelperSecondPassword ? true : false}
          helperText={
            isShowHelperSecondPassword && "זו לא אותה סיסמה שהקלדת קודם"
          }
          setIsError={setIsError}
          endAdornment={true}
          //showHelperText={true}
          value={formData.secondPassword ? formData.secondPassword : ""}
          setValue={handleChangeFormData}
        />
        <div className="register-email-policy register-newsletter-margin">
          <FormControlLabel
            label={getTranslation(consts.I_WANT_TO_RECEIVE_NEWSLETTER)}
            control={
              <Checkbox
                role="newsletter-checkbox-register"
                checked={checkedNewsletter}
                onChange={(event) =>
                  handleChange(
                    event.target.checked,
                    setCheckedNewsletter,
                    false
                  )
                }
                className="login-remember-me-check-box"
              />
            }
          />
        </div>
        <div className="register-email-policy register-terms-margin">
          <FormControlLabel
            className="register-email-policy register-email-policy-mb"
            label={
              <>
                {renderTermsTemplate({ template: licenseTemplate, placeholders })}
              </>
            }
            control={
              <Checkbox
                role="policy-checkbox-register"
                checked={checkedTerms}
                onChange={(event) =>
                  handleChange(event.target.checked, setCheckedTerms, true)
                }
                className="login-remember-me-check-box"
              />
            }
          />
          {checkboxClicked && !checkedTerms && (
            <FormHelperText
              role="policy-helper-register"
              className="font_xs color_red"
            >
              {getTranslation(consts.APPROVE_POLICY_HELPER)}
            </FormHelperText>
          )}
        </div>
        <div>
          <NextButton
            class="btn-fp-mail"
            testid="btn-register"
            handleOnClick={handleOnClick}
            text={getTranslation(consts.CREATE_ACCOUNT)}
          ></NextButton>
        </div>
      </div>
    </>
  );
}
export default Register;
